/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * Somebody's initials.
 *
 * Decorative: the name is always beside it, so the avatar is hidden from a
 * screen reader rather than read out twice.
 */
export function Avatar({ initials, size }: { initials: string; size?: 'sm' | 'lg' }) {
  return (
    <span className={`av${size ? ` ${size}` : ''}`} aria-hidden>
      {initials}
    </span>
  );
}
